import React from "react";
import { useLang } from "@/context/LanguageContext";

export default function OfficeStructure() {
    const { t } = useLang();
    const r = t.structure.roles;

    return (
        <div data-testid="structure-page">
            <section className="bg-[#1A365D] text-white pt-20 pb-16 md:pt-28 md:pb-24">
                <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
                    <div className="small-caps text-[#F5B76E] mb-4">
                        {t.structure.eyebrow}
                    </div>
                    <h1 className="font-serif font-bold text-4xl sm:text-5xl lg:text-6xl leading-tight max-w-4xl mb-6">
                        {t.structure.title}
                    </h1>
                    <p className="max-w-3xl text-gray-300 leading-relaxed">
                        {t.structure.subtitle}
                    </p>
                </div>
            </section>

            <section className="py-16 md:py-24 bg-white">
                <div className="max-w-6xl mx-auto px-6 md:px-12">
                    {/* Org chart */}
                    <div className="flex flex-col items-center gap-8">
                        {/* Level 1 */}
                        <OrgNode
                            level={1}
                            title={r.commissioner}
                            note="Chennai HQ"
                            testid="node-commissioner"
                        />
                        <Connector />
                        <OrgNode
                            level={1}
                            title={r.director}
                            note="Directorate"
                            testid="node-director"
                        />
                        <Connector />
                        <OrgNode
                            level={1}
                            title={r.gm}
                            note="District Head"
                            testid="node-gm"
                        />
                        <Connector />

                        {/* Level 2 — Managers row */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full">
                            <OrgNode
                                level={2}
                                title={r.mgr}
                                note="Credit & Schemes"
                                testid="node-mgr-credit"
                            />
                            <OrgNode
                                level={2}
                                title={r.mgr}
                                note="EDP & Training"
                                testid="node-mgr-edp"
                            />
                            <OrgNode
                                level={2}
                                title={r.mgr}
                                note="Estates & Infra"
                                testid="node-mgr-estates"
                            />
                        </div>
                        <Connector />

                        {/* Level 3 — Assistant Managers */}
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 w-full">
                            <OrgNode level={3} title={r.amgr} note="MSME Cell" />
                            <OrgNode level={3} title={r.amgr} note="Scheme Desk" />
                            <OrgNode level={3} title={r.amgr} note="Cluster Cell" />
                            <OrgNode level={3} title={r.amgr} note="Marketing" />
                        </div>
                        <Connector />

                        {/* Level 4 — Field Officers */}
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 w-full">
                            <OrgNode level={4} title={r.io} note="Zone 1" />
                            <OrgNode level={4} title={r.io} note="Zone 2" />
                            <OrgNode level={4} title={r.io} note="Zone 3" />
                            <OrgNode level={4} title={r.io} note="Zone 4" />
                        </div>
                        <Connector />

                        <OrgNode
                            level={5}
                            title={r.ta}
                            note="Support Staff"
                            testid="node-support"
                        />
                    </div>
                </div>
            </section>
        </div>
    );
}

function OrgNode({ level, title, note, testid }) {
    const colors = {
        1: "bg-[#1A365D] text-white border-[#DD6B20]",
        2: "bg-white text-[#1A365D] border-[#1A365D]",
        3: "bg-[#F7FAFC] text-[#1A365D] border-gray-300",
        4: "bg-white text-gray-700 border-gray-300",
        5: "bg-white text-gray-500 border-gray-200",
    };
    return (
        <div
            className={`w-full md:w-auto md:min-w-[280px] px-6 py-4 border-2 rounded-lg text-center ${colors[level]}`}
            data-testid={testid}
        >
            <div className="font-serif font-semibold text-base md:text-lg leading-snug">
                {title}
            </div>
            {note && <div className="small-caps mt-2 opacity-80 text-[10px]">{note}</div>}
        </div>
    );
}

function Connector() {
    return <div className="w-[2px] h-6 bg-gray-300" aria-hidden />;
}
